<script setup lang="ts">
import { computed, toRef } from "vue";
import { Select } from "@/components/episto-ui/select";
import { useCardLocalOptions } from "@/composables/useCardLocalOptions";
import type { DisplayedPopulation } from "@/types";

const props = defineProps<{
  card: { id: number; options?: Record<string, unknown> | null };
  populations: Pick<DisplayedPopulation, "token" | "label">[];
  selected: string;
}>();

const { updateLocalOption } = useCardLocalOptions(toRef(props, "card"));

const options = computed(() => props.populations.map((pop) => ({ value: pop.token, label: pop.label })));
</script>

<template>
  <Select
    :model-value="selected"
    :options="options"
    class="w-36"
    @update:model-value="updateLocalOption('population', $event)" />
</template>
